(() => {
  'use strict';
  if (window.yhsSKPDPV2) return;
  window.yhsSKPDPV2 = true;
  let lastOpener;
  const desktop = matchMedia('(min-width: 750px)');
  const adaptDecisions = () => document.querySelectorAll('.skpdp__rows--customization').forEach(list => {
    list.querySelectorAll('details').forEach((row, i) => row.open = desktop.matches || i === 0);
  });
  desktop.addEventListener('change',adaptDecisions);
  const init = () => {
    document.querySelectorAll('.skpdp__rows--customization').forEach(list => {
      if (list.dataset.skpdpReady) return;
      list.dataset.skpdpReady = 'true';
      list.querySelectorAll('details').forEach((row, i) => row.open = desktop.matches || i === 0);
    });
    document.querySelectorAll('[data-skpdp-views]').forEach(root => {
      if (root.dataset.skpdpReady) return;
      root.dataset.skpdpReady = 'true';
      const first = root.querySelector('[data-skpdp-view]');
      if (first) selectView(root, first);
    });
    document.querySelectorAll('[data-skpdp-nav]').forEach(nav => {
      const kinds = ['overview','definition','dimensions','interfaces','buildup','customization','approvals','review'];
      const labels = nav.dataset.navLabels.split('|');
      const roots = [...document.querySelectorAll('.skpdp[data-skpdp-kind]')];
      nav.firstElementChild.replaceChildren(...kinds.flatMap((kind, i) => {
        const target = roots.find(root => root.dataset.skpdpKind === kind);
        if (!target) return [];
        const a = document.createElement('a');
        a.href = `#${target.id}`;
        a.textContent = labels[i] || kind;
        return [a];
      }));
      nav.hidden = !roots.length;
    });
    schedule();
  };
  const selectView = (root, selected) => {
    root.querySelectorAll('[data-skpdp-view]').forEach(tab => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-skpdp-view-panel]').forEach(panel => panel.hidden = panel.id !== selected.dataset.skpdpView);
  };
  document.addEventListener('click', event => {
    const root = event.target.closest('.skpdp');
    const thumb = event.target.closest('[data-skpdp-thumb]');
    if (root && thumb) {
      const gallery = thumb.closest('[data-skpdp-gallery]');
      gallery.querySelectorAll('[data-skpdp-media]').forEach(media => {
        media.hidden = media.id !== thumb.dataset.skpdpThumb;
        if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
        else gallery.querySelector('[data-skpdp-gallery-caption]').textContent = media.dataset.caption || '';
      });
      gallery.querySelectorAll('[data-skpdp-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const tab = event.target.closest('[data-skpdp-view]');
    if (root && tab) selectView(tab.closest('[data-skpdp-views]'),tab);
    const pin = event.target.closest('[data-skpdp-pin]');
    if (root && pin) {
      const target = document.getElementById(pin.dataset.skpdpPin);
      if (target) {
        root.querySelectorAll('[data-skpdp-row]').forEach(row => row.open = row === target);
        root.querySelectorAll('[data-skpdp-pin]').forEach(button => button.setAttribute('aria-pressed', String(button === pin)));
        target.querySelector('summary').focus({preventScroll:true});
      }
    }
    const opener = event.target.closest('[data-skpdp-enlarge]');
    if (root && opener) {
      const img = opener.querySelector('img'), dialog = document.querySelector('[data-skpdp-dialog]');
      if (img && dialog) {
        lastOpener = opener;
        const large = dialog.querySelector('img');
        large.src = img.currentSrc || img.src;
        large.alt = img.alt;
        dialog.querySelector('[data-skpdp-viewer-caption]').textContent = opener.closest('[data-skpdp-media]')?.dataset.caption || opener.dataset.caption || img.alt;
        const zoom = dialog.querySelector('[data-skpdp-zoom]');
        zoom.setAttribute('aria-pressed','false'); zoom.textContent = zoom.dataset.zoomLabel;
        dialog.querySelector('.skpdp__viewer-stage').removeAttribute('data-zoomed');
        dialog.showModal();
      }
    }
    const zoom = event.target.closest('[data-skpdp-zoom]');
    if (zoom) {
      const stage = zoom.closest('dialog').querySelector('.skpdp__viewer-stage');
      const on = stage.toggleAttribute('data-zoomed');
      zoom.setAttribute('aria-pressed',String(on)); zoom.textContent = on ? zoom.dataset.fitLabel : zoom.dataset.zoomLabel;
    }
    const close = event.target.closest('[data-skpdp-close]');
    if (close) close.closest('dialog').close();
    const inquiry = event.target.closest('.skpdp [data-pdp-inquiry]');
    if (inquiry) {
      const next = new URL(inquiry.href,location.href);
      const store = new URL(inquiry.dataset.pdpStoreOrigin,location.href).origin;
      if (location.hostname.endsWith('.shopifypreview.com') && next.origin === store) next.host = location.host;
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview && next.origin === location.origin) next.searchParams.set('preview_theme_id',preview);
      inquiry.href = next.href;
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('.skpdp [data-skpdp-view]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[data-skpdp-views]').querySelectorAll('[data-skpdp-view]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[index].focus(); tabs[index].click();
  });
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-skpdp-dialog]')) lastOpener?.focus({preventScroll:true});
  },true);
  let queued = false;
  const measure = () => {
    queued = false;
    const nav = document.querySelector('[data-skpdp-nav]:not([hidden])');
    if (!nav) return;
    const box = document.querySelector('.section-header')?.getBoundingClientRect();
    const top = box && box.bottom > 0 && box.top < innerHeight ? Math.min(box.bottom,innerHeight / 2) : 0;
    document.querySelectorAll('.skpdp, .skpdp__nav').forEach(root => {
      root.style.setProperty('--apdp-header-offset',`${Math.round(top)}px`);
      root.style.setProperty('--apdp-nav-height',`${Math.round(nav.offsetHeight)}px`);
    });
    const links = [...nav.querySelectorAll('a')]; let active = links[0];
    links.forEach(a => { if (document.getElementById(a.hash.slice(1))?.getBoundingClientRect().top <= top + nav.offsetHeight + 60) active = a; });
    links.forEach(a => { if (a === active) a.setAttribute('aria-current','location'); else a.removeAttribute('aria-current'); });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(measure); } };
  addEventListener('scroll',schedule,{passive:true}); addEventListener('resize',schedule);
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(name => document.addEventListener(name,init));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
